import {ValidacaoService} from './../../service/validacao.service';
import {WizardComponent} from 'angular-archwizard';
import {ModalService} from './../../service/modal.service';
import {FormBuilder} from '@angular/forms';
import {ToadMensagemService} from './../../service/toad-mensagem.service';
import {FtaService} from './../../service/fta.service';
import {PesquisasFiltroApiService} from './../../service/api/pesquisas-filtro.api';
import {GlobalService} from './../../service/global.service';
import {CatalogoApiService} from './../../service/api/catalogo.api';
import {Evento, EventoProcessamento, Cliente, MCI, UOR, UserAplicacao} from './../../model/catalogo';
import {Component, OnInit, OnChanges, Output, Input, EventEmitter, ViewChild} from '@angular/core';


@Component({
    selector: 'app-detalhe-evento-processamento',
    templateUrl: './detalhe-evento-processamento.component.html',
    styleUrls: ['./detalhe-evento-processamento.component.css'],
    providers: [ValidacaoService]
})
export class DetalheEventoProcessamentoComponent implements OnInit {

    listaItemConfiguracaoProduto = [];

    mci: MCI = new MCI();
    uor: UOR = new UOR();
    userAplicacao: UserAplicacao = new UserAplicacao();

    selecionaCliente: String;

    processamentoFilho: EventoProcessamento = new EventoProcessamento();

    @Output() eventoProcessamentoAdiconado = new EventEmitter();
    @Input() novoEventoProcessamento: EventoProcessamento;
    @Input() evento: Evento;

    eventoLocal: Evento;

    //salvar evento
    @Output() eventoAlterado = new EventEmitter();

    @Output() eventoCancelado = new EventEmitter();

    cliente: Cliente = new Cliente();

    constructor(
        private messageService: ToadMensagemService,
        private formBuilder: FormBuilder,
        private modalService: ModalService,
        private catalogoApi: CatalogoApiService,
        private globalService: GlobalService,
        public pesquisaService: PesquisasFiltroApiService,
        public ftaService: FtaService,
        public validacaoService: ValidacaoService,
        @ViewChild(WizardComponent)
        public wizard: WizardComponent
    ) {
    }

    ngOnInit() {
    }

    // Um método de retorno uma chamada que executa a detecção de alterações
    ngDoCheck(): void {
        if (this.novoEventoProcessamento != undefined) {
            this.processamentoFilho = new EventoProcessamento();
            this.processamentoFilho = this.novoEventoProcessamento;
            this.eventoProcessamentoAdiconado.emit(this.processamentoFilho);
        }
    }

    ngOnChanges() {
        this.eventoLocal = this.evento;

        if (this.novoEventoProcessamento != undefined) {
            if (this.novoEventoProcessamento.mascaraNomeArquivoProcessado === 'null') {
                this.novoEventoProcessamento.mascaraNomeArquivoProcessado = '';
            }

            if (this.novoEventoProcessamento.siglaSistemaMainframeResponsavelProcessamento === 'null') {
                this.novoEventoProcessamento.siglaSistemaMainframeResponsavelProcessamento = '';
            }

            if (this.novoEventoProcessamento.programaMainframeResponsavelProcessamento === 'null') {
                this.novoEventoProcessamento.programaMainframeResponsavelProcessamento = '';
            }

            if (this.novoEventoProcessamento.programaBaixaPlataformaResponsavelProcessamento === 'null') {
                this.novoEventoProcessamento.programaBaixaPlataformaResponsavelProcessamento = '';
            }
        }
    }

    finishFunction() {
        let userAplicacao = new UserAplicacao();
        this.processamentoFilho.clienteResponsavelProcessamento = this.cliente;
        let usuario = this.globalService.usuario;

        //TODO VERIFICAR COM OS ANALISTAS DO BANCO COMO RECUPERAR ESSE CODIGO E VERSAO DO USUARIO LOGADO (TESTE)
        userAplicacao.codUserAplicacao = 121;
        userAplicacao.versaoUserAplicacao = 2;

        this.processamentoFilho.clienteResponsavelProcessamento.userAplicacao = userAplicacao;

        if (this.validacaoService.validaEvento(this.eventoLocal)) {
            this.eventoAlterado.emit(true);
            this.wizard.navigation.reset();
        }

    }

    cancelarEvento() {
        this.eventoCancelado.emit(this.evento);
    }

    carregarCliente() {
        this.modalService.abrirPaginaModal('cliente-modal', {}, {'selecionaAutomatico': true}, 'Selecionar Tipo Cliente', 'Fechar').subscribe(cliente => {
            if (cliente != null) {
                this.cliente = cliente;

                if (this.cliente.mci !== null) {
                    this.mci = this.cliente.mci;
                    this.apresentaMCI(this.mci);
                }
                if (this.cliente.uor !== null) {
                    this.uor = this.cliente.uor;
                    this.apresentaUOR(this.uor);
                } else {
                    this.userAplicacao = this.cliente.userAplicacao;
                    this.apresentaUserAplicacao(this.userAplicacao);
                }

            }
        });
    }

    apresentaMCI(mci: MCI) {
        if (mci != null) {
            this.selecionaCliente = mci.nomeCliente;
        }
    }

    apresentaUOR(uor: UOR) {
        if (uor != null) {
            this.selecionaCliente = uor.nomeDependencia;
        }
    }

    apresentaUserAplicacao(userAplicacao: UserAplicacao) {
        if (userAplicacao != null) {
            this.selecionaCliente = userAplicacao.nomeUserAplicacao;
        }
    }

    deletarCliente() {
        this.cliente = new Cliente();
        this.selecionaCliente = null;
    }

    // salvarProcessamento() {

    //   this.processamentoFilho.clienteResponsavelProcessamento = this.cliente;


    //   let userAplicacao = new UserAplicacao();
    //   userAplicacao.codUserAplicacao = 0;
    //   userAplicacao.versaoUserAplicacao = 0;
    //   userAplicacao.descricaoUserAplicacao = "Usuário Impessoal - Uso Interno - Criado via template";
    //   userAplicacao.nomeUserAplicacao = 'teste';
    //   this.processamentoFilho.clienteResponsavelProcessamento.userAplicacao = userAplicacao;

    //   this.eventoProcessamentoAdiconado.emit(this.processamentoFilho);

    // }

    onSubmit() {

    }
}



// WEBPACK FOOTER //
// ./src/app/detalhe-evento-processamento/detalhe-evento-processamento.component.ts